import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { EditUserForm } from './EditUserForm';
import { User } from '@/types/User';

interface EditUserDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  user: User | null;
  onUserUpdated: () => void;
  onDataRefresh?: () => void;
  isCurrentUser?:boolean;
}

export const EditUserDialog: React.FC<EditUserDialogProps> = ({
  open,
  onOpenChange,
  user,
  onUserUpdated,
  onDataRefresh,
  isCurrentUser=false
}) => {
  if (!user) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="dark bg-background text-foreground max-w-5xl max-h-[95vh] overflow-y-auto">
        <DialogHeader>
          <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">
            User Management
          </p>
          <DialogTitle className="text-xl">Edit User</DialogTitle>
          <DialogDescription className="sr-only">
            Update user information, roles, and preferences.
          </DialogDescription>
        </DialogHeader>

        <EditUserForm
          isCurrentUser={isCurrentUser}
          user={user}
          onUserUpdated={onUserUpdated}
          onDataRefresh={onDataRefresh}
          onCancel={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
};